import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="relay"
export default class extends Controller {
  forward(e: CustomEvent): void {
    const subscribers = this.element.querySelectorAll(`[data-relay-events*='${e.type}']`);

    subscribers.forEach((el) => {
      el.dispatchEvent(new CustomEvent(e.type, { detail: e.detail }));
    });
  }
}
